module.exports = __webpack_public_path__ + "img/indu_14.83575d50.png";